import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import api, { operation } from '../services/axios'
import { StoreState } from '../store'

interface CommissionProtocol {
    valoresVariaveis: ValoresVariaveisProtocol[]
}

interface ValoresVariaveisProtocol {
    id: number
    comissaoVariavelId: number
    valor1: number | string
    valor2: number | string
    tipo: string
    tipoTaxaCobranca: string
    valorTaxa: number | string
    valorTaxaLink: number | string
    createdAt: string | null
    updatedAt: string | null
    deleteAt: string | null
}

export const useCommision = () => {
    const [commission, setCommission] = useState<CommissionProtocol>(
        {} as CommissionProtocol
    )
    // const [paymentCommission, setPaymentCommission] = useState()
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)

    const getCommission = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                setCommission(data)
            } catch (error) {}
        })
    }, [cnpj_cpf])

    useEffect(() => {
        getCommission()
    }, [getCommission])

    function getBillingCommission(valueLink: number) {
        const commissionFound = commission?.valoresVariaveis?.find(
            (commission: ValoresVariaveisProtocol) => {
                return (
                    Number(commission.valor1) <= valueLink &&
                    Number(commission.valor2) >= valueLink
                )
            }
        )

        let commissonValue = Number(commissionFound?.valorTaxaLink) || 0
        if (commissionFound?.tipoTaxaCobranca === 'porcentagem') {
            commissonValue =
                Number((commissonValue * valueLink).toFixed(2)) || 0
        }

        return commissonValue
    }

    function getPaymentCommission(valuePayment: number) {
        const commissionFound = commission?.valoresVariaveis?.find(
            (commission: ValoresVariaveisProtocol) => {
                return (
                    Number(commission.valor1) <= valuePayment &&
                    Number(commission.valor2) >= valuePayment
                )
            }
        )

        let commissonValue = Number(commissionFound?.valorTaxa) || 0
        if (commissionFound?.tipo === 'porcentagem') {
            commissonValue =
                Number((commissonValue * valuePayment).toFixed(2)) || 0
        }

        return commissonValue
    }

    return {
        getBillingCommission,
        getPaymentCommission,
    }
}
